import {
    GET_USER_ON_SEARCH,
    SET_USER_ON_SEARCH,
    GET_BRANCH_ADMIN_USER_DETAILS,
    SET_BRANCH_ADMIN_USER_DETAILS,
    GET_COST_CENTER_GRID_BY_USERID,
    SET_COST_CENTER_GRID_BY_USERID,
    GET_IS_COSTCENTER_SAVED_SUCCESSFULLY,
    SET_IS_COSTCENTER_SAVED_SUCCESSFULLY,
    GET_IS_COSTCENTER_VALID_FOR_SAVE,
    SET_IS_COSTCENTER_VALID_FOR_SAVE,
    GET_REMOVE_COST_CENTER_FOR_USER,
    SET_IS_REMOVE_COST_CENTER_FOR_USER,
    GET_COST_CENTER_BYID_AND_ROLE,
    SET_COST_CENTER_BYID_AND_ROLE
} from "./BranchAdminAccessType"

const getUserOnSearch = (val: any) => ({
    type: GET_USER_ON_SEARCH,
    val
});

const setUserOnSearch = (userListOnSearch: any) => ({
    type: SET_USER_ON_SEARCH,
    userListOnSearch: userListOnSearch
});

const getBranchAdminUserDetails = (val: any) => ({
    type: GET_BRANCH_ADMIN_USER_DETAILS,
    val
});

const setBranchAdminUserDetails = (branchAdminUserDetails: any) => ({
    type: SET_BRANCH_ADMIN_USER_DETAILS,
    branchAdminUserDetails: branchAdminUserDetails
});

const getCostCenterGridByUserId = (val: any) => ({
    type: GET_COST_CENTER_GRID_BY_USERID,
    val
});

const setCostCenterGridByUserId = (costCenterGridByUserId: any) => ({
    type: SET_COST_CENTER_GRID_BY_USERID,
    costCenterGridByUserId: costCenterGridByUserId
});

const getIsCostCenterSavedSuccessfully = (val: any) => ({
    type: GET_IS_COSTCENTER_SAVED_SUCCESSFULLY,
    val
});

const setIsCostCenterSavedSuccessfully = (isCostCenterSavedSuccessfully: any) => ({
    type: SET_IS_COSTCENTER_SAVED_SUCCESSFULLY,
    isCostCenterSavedSuccessfully: isCostCenterSavedSuccessfully
});

const getIsCostCenterValidForSave = (val: any) => ({
    type: GET_IS_COSTCENTER_VALID_FOR_SAVE,
    val
});

const setIsCostCenterValidForSave = (isCostCenterValidForSave: any) => ({
    type: SET_IS_COSTCENTER_VALID_FOR_SAVE,
    isCostCenterValidForSave: isCostCenterValidForSave
});

const getRemoveCostCenterForUser = (val: any) => ({
    type: GET_REMOVE_COST_CENTER_FOR_USER,
    val
});

const setIsRemoveCostCenterForUser = (isRemoveCostCenterForUser: any) => ({
    type: SET_IS_REMOVE_COST_CENTER_FOR_USER,
    isRemoveCostCenterForUser: isRemoveCostCenterForUser
});

const getCostCenterByIdAndRole = (val: any) => ({
    type: GET_COST_CENTER_BYID_AND_ROLE,
    val
});

const setCostCenterByIdAndRole = (costCenterByIdAndRole: any) => ({
    type: SET_COST_CENTER_BYID_AND_ROLE,
    costCenterByIdAndRole: costCenterByIdAndRole
});

export {
    getUserOnSearch,
    setUserOnSearch,
    getBranchAdminUserDetails,
    setBranchAdminUserDetails,
    getCostCenterGridByUserId,
    setCostCenterGridByUserId,
    getIsCostCenterSavedSuccessfully,
    setIsCostCenterSavedSuccessfully,
    getIsCostCenterValidForSave,
    setIsCostCenterValidForSave,
    getRemoveCostCenterForUser,
    setIsRemoveCostCenterForUser,
    getCostCenterByIdAndRole,
    setCostCenterByIdAndRole
}
